import ArrowBackIos from '@mui/icons-material/ArrowBackIos'
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos'
import { IconButton, styled } from '@mui/material'

const StyledIconButton = styled(IconButton)(() => ({
  position: 'absolute',
  top: '50%',
  marginTop: -28,
  width: 56,
  height: 56,
  backgroundColor: 'rgba(238,238,238, 0.5)',
  zIndex: 1,
  '&:hover': {
    backgroundColor: '#eeeeee'
  }
}))

export function RenderArrowPrev(clickHandler: () => void, hasPrev: boolean, label: string) {
  if (!hasPrev) return null

  return (
    <StyledIconButton onClick={clickHandler} aria-label={label} style={{ left: 12 }} data-test="prev-img">
      <ArrowBackIos />
    </StyledIconButton>
  )
}

export function RenderArrowNext(clickHandler: () => void, hasNext: boolean, label: string) {
  if (!hasNext) return null

  return (
    <StyledIconButton onClick={clickHandler} aria-label={label} style={{ right: 12 }} data-test="next-img">
      <ArrowForwardIos />
    </StyledIconButton>
  )
}
